import React, { useEffect, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { FacilityCard } from "./FacilityCard";
import { Col, Row, Spinner } from "react-bootstrap";
import "./Facility.scss";
import { DeleteModal } from "../Modals/DeleteModal";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteFacility,
  facilityList,
  setCurrentData,
} from "../../../redux/actions/dbactions/facilityActions";
import { EditModal } from "./EditModal";
import { VerifyFacility } from "./VerifyFacility";
import { refTypesList } from "../../../redux/actions/dbactions/refactions";
import { fetchIntervals } from "../../../redux/actions/calenderActions";
import { NewCalender } from "./NewCalender";
import { getSession } from "../../../redux/actions/authActions";
import { Header } from "../../Header";
import FacilitiesIcon from "../../../../assets/FacilitiesIcon";

const Facilities = ({ searchQuery }) => {
  const dispatch = useDispatch();
  const { role_id } = getSession();
  const { facility, isLoading } = useSelector((state) => state.facilitylist);
  const { intervals, loading } = useSelector((state) => state.intervalReducer);
  const [show, setShow] = useState(false);
  const [editmodal, setEditmodal] = useState(false);
  const [verifymodal, setVerifymodal] = useState(false);
  const [calenderModal, setCalenderModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedTitle, setSelectedTitle] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [selectedCountryId, setSelectedCountryId] = useState(null);

  // Modal open
  const handleShow = (svcf_id, svcf_name) => {
    setShow(true);
    setRefresh(false);
    setSelectedId(svcf_id);
    setSelectedTitle(svcf_name);
  };

  // Facility API call
  useEffect(() => {
    dispatch(facilityList("all"));
    dispatch(refTypesList());
  }, [dispatch, refresh]);

  // Refresh facility list when calendar modal is closed
  useEffect(() => {
    if (!calenderModal && refresh) {
      dispatch(facilityList("all"));
      setRefresh(false);
    }
  }, [calenderModal, refresh, dispatch]);
  // Facility API call on refresh
  // useEffect(() => {
  //   if (refresh) {
  //     dispatch(facilityList("all"));
  //   }
  // }, [dispatch, refresh]);

  const values = Object.values(facility);

  const handleEditModal = (data) => {
    setEditmodal(true);
    setRefresh(false);
    dispatch(setCurrentData(data));
    setSelectedCountryId(data.svcf_iso_cntry_id);
  };
  const handleVerifyFacility = (data) => {
    setVerifymodal(true);
    setRefresh(false);
    dispatch(setCurrentData(data));
  };
  // Delete functionality
  const handleDelete = () => {
    if (selectedId) {
      dispatch(deleteFacility(selectedId));
      setRefresh(true);
      setShow(false);
    }
  };

  const handleCalenderShow = (svcf_name, svcf_id) => {
    dispatch(fetchIntervals(svcf_id));
    setSelectedId(svcf_id);
    setSelectedTitle(svcf_name);
    setCalenderModal(true);
    setRefresh(true);
  };

  const slots = intervals.usr?.rec[intervals.usr?.rec.length - 1] || [];

  const closeCalender = () => {
    setCalenderModal(false);
    setSelectedId(null);
  };

  // Filter facilities based on search query
  const filteredValues = values.filter(
    (item) =>
      Array.isArray(item.rec) &&
      item.rec.some((record) =>
        record.svcf_name.toLowerCase().includes(searchQuery.toLowerCase())
      )
  );

  return (
    <div className="facilities">
      <Header pageTitle="Facilities & Services" icon={<FacilitiesIcon />} />
      <div className="px-[0.75rem] sm:px-8 mt-4 flex items-center justify-between mb-3">
        <h5 className="text-base sm:text-[26px] w-full whitespace-nowrap">
          Facilities & Services
        </h5>
        <div className="w-fit whitespace-nowrap">
          {role_id === "5" ? (
            ""
          ) : (
            <Link
              to={`/dashboard/new-facility`}
              className="!text-xs sign_btn text-center"
            >
              + Add New Facility
            </Link>
          )}
        </div>
      </div>
      {isLoading ? (
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : null}
      <Row className="m-0 sm:px-6">
        {filteredValues.length > 0 ? (
          filteredValues.map((item, index) => (
            <div key={index}>
              <Row>
                {item.rec
                  .filter((record) =>
                    record.svcf_name
                      .toLowerCase()
                      .includes(searchQuery.toLowerCase())
                  )
                  .map((record, subIndex) => (
                    <Col
                      className="mb-3"
                      lg={4}
                      md={6}
                      key={`${index}_${subIndex}`}
                    >
                      <FacilityCard
                        data={record}
                        dispatch={dispatch}
                        handleShow={() =>
                          handleShow(record.svcf_id, record.svcf_name)
                        }
                        handleEditModal={handleEditModal}
                        roleID={role_id}
                        handleCalenderShow={() =>
                          handleCalenderShow(record.svcf_name, record.svcf_id)
                        }
                        handleVerifyFacility={() =>
                          handleVerifyFacility(record)
                        }
                        route={"facilities"}
                      />
                    </Col>
                  ))}
              </Row>
            </div>
          ))
        ) : (
          <Col>
            <p className="text-center">No facility found</p>
          </Col>
        )}
      </Row>
      <DeleteModal
        handleDelete={handleDelete}
        show={show}
        handleClose={() => setShow(false)}
        selectedTitle={selectedTitle}
      />
      <VerifyFacility
        show={verifymodal}
        onHide={() => setVerifymodal(false)}
        dispatch={dispatch}
        setRefresh={setRefresh}
        setVerifymodal={setVerifymodal}
      />
      <EditModal
        show={editmodal}
        onHide={() => setEditmodal(false)}
        dispatch={dispatch}
        selectedCountryId={selectedCountryId}
        setSelectedCountryId={setSelectedCountryId}
        setRefresh={setRefresh}
        setEditmodal={setEditmodal}
      />
      {calenderModal && (
        <NewCalender
          show={calenderModal}
          onHide={closeCalender}
          selectedTitle={selectedTitle}
          selectedId={selectedId}
          slots={slots}
          loading={loading}
        />
      )}
    </div>
  );
};

export default withRouter(Facilities);
